<template>
    <div class="info-display">
        <div class="images" v-if="content.images">
            <div class="image" v-for="image of content.images" :key="image as string"
                :class="{ active: isActive(image) }"
                :style="{ 'background-image': ui.getBackgroundImageUrl(image, 600)! }"></div>

            <div class="image-navigation" v-if="content.images.length > 1">
                <a href="#" class="previous" @click.prevent="move(-1)">
                    <span class="icon-angle-left"></span>
                </a>
                <a href="#" class="next" @click.prevent="move(+1)">
                    <span class="icon-angle-right"></span>
                </a>
            </div>
        </div>

        <div class="text-content">
            <h3>{{ content.title }}</h3>

            <div class="text" v-if="content.text" v-html="content.text"></div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { useUI } from '../store';


const { 
    content
 } = defineProps<{ 
    content: any
 }>();

let activeImage: any = null;

const { ui } = useUI();

function created() {
    if (content.images)
        activeImage = content.images[0];
}

function move(direction: number) {
    let index = content.images.indexOf(activeImage) + direction;

    if (index < 0)
        index = content.images.length - 1;

    if (index >= content.images.length)
        index = 0;

    activeImage = content.images[index];
}

function isActive(image: string) {
    return activeImage == image;
}

</script>
